/*
 * Eventi comportamentali Guestside verso il custom pixel.
 *
 * Perche' publish() e non dataLayer.push: il container GTM di questo negozio e'
 * un custom pixel, e i custom pixel girano in un iframe isolato -- il dataLayer
 * del tema e quello dentro il pixel sono due oggetti diversi. Il ponte
 * supportato e' Shopify.analytics.publish() qui e analytics.subscribe() la'.
 *
 * Tutto sta in un file solo perche' i punti di aggancio sono sparsi in sei
 * asset diversi: la normalizzazione degli errori scritta sei volte sarebbe sei
 * versioni che divergono.
 *
 * Nessun dato personale viaggia in questi eventi: niente email, niente campi
 * compilati dall'utente. Codici e id prodotto non sono dati personali.
 */
window.GuestsideAnalytics = (function () {
  var inviati = {};

  function pubblica(nome, dati) {
    if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') {
      return false;
    }
    Shopify.analytics.publish('guestside:' + nome, dati);
    return true;
  }

  // Alcuni eventi non devono ripetersi nella stessa visualizzazione. Si segna
  // come inviato solo se e' partito davvero: marcarlo prima brucerebbe l'evento
  // ogni volta che Shopify.analytics non e' ancora pronto.
  function pubblicaUnaVolta(nome, chiave, dati) {
    var registro = nome + ':' + chiave;
    if (inviati[registro]) return false;
    var esito = pubblica(nome, dati);
    if (esito) inviati[registro] = true;
    return esito;
  }

  /*
   * Errore in aggiunta al carrello.
   *
   * Si aggancia alla Response della fetch esistente e non sostituisce nulla:
   * il corpo viene letto da un clone, cosi' il flusso originale trova lo stream
   * intatto. Shopify risponde 422 con {status, message, description} quando il
   * prodotto e' finito o la quantita' non e' disponibile.
   *
   * Il messaggio grezzo NON viene inviato: si normalizza in poche categorie,
   * altrimenti in GA4 ci si ritrova decine di varianti dello stesso errore.
   */
  function normalizzaErrore(stato, descrizione) {
    var testo = (descrizione || '').toLowerCase();
    if (stato === 429) return 'rate_limit';
    if (stato === 422) {
      // Shopify usa lo stesso 422 per "finito" e "ne restano meno di quanti
      // ne vuoi": il messaggio e' l'unico modo per separarli.
      if (testo.indexOf('sold out') >= 0 || testo.indexOf('esaurit') >= 0 ||
          testo.indexOf('non disponibile') >= 0 || testo.indexOf('unavailable') >= 0) {
        return 'sold_out';
      }
      return 'quantity_unavailable';
    }
    if (stato >= 500) return 'unknown';
    return 'unknown';
  }

  function datiDalCorpo(body) {
    var fuori = { item_variant_id: null, quantity: null };
    try {
      if (body instanceof FormData) {
        fuori.item_variant_id = body.get('id');
        fuori.quantity = Number(body.get('quantity')) || 1;
      } else if (typeof body === 'string') {
        // Le due forme in uso nel tema: JSON (cart.js) e form-urlencoded.
        if (body.charAt(0) === '{') {
          var oggetto = JSON.parse(body);
          fuori.item_variant_id = oggetto.id;
          fuori.quantity = Number(oggetto.quantity) || 1;
        } else {
          var p = new URLSearchParams(body);
          fuori.item_variant_id = p.get('id');
          fuori.quantity = Number(p.get('quantity')) || 1;
        }
      }
    } catch (e) {
      /* body in un formato che non conosciamo: si spedisce senza */
    }
    return fuori;
  }

  function osservaAggiuntaCarrello(response, config) {
    // Rete di protezione: qualunque cosa vada storta qui non deve impedire
    // l'aggiunta al carrello, che e' il lavoro vero della pagina.
    try {
      if (!response || response.ok) return response;
      var base = datiDalCorpo(config && config.body);
      response.clone().json().then(function (errore) {
        var dati = {
          item_variant_id: base.item_variant_id,
          quantity: base.quantity,
          error_type: normalizzaErrore(response.status, errore && errore.description),
          http_status: response.status
        };
        // sku e nome li conosce la scheda prodotto. Da una card di collezione o
        // dalla quick view non sono a portata: in quel caso restano fuori
        // invece di essere indovinati.
        var prodotto = window.__guestsideProdottoPagina;
        var sku = prodotto && prodotto.varianti && prodotto.varianti[String(base.item_variant_id)];
        if (sku !== undefined) {
          dati.item_id = sku;
          dati.item_name = prodotto.item_name;
          dati.item_product_id = prodotto.item_product_id;
        }
        pubblica('add_to_cart_error', dati);
      }).catch(function () {
        pubblica('add_to_cart_error', {
          item_variant_id: base.item_variant_id,
          quantity: base.quantity,
          error_type: 'unknown',
          http_status: response.status
        });
      });
    } catch (e) {
      /* niente */
    }
    return response;
  }

  /*
   * Filtro applicato o rimosso.
   *
   * Va pubblicato quando il filtro ha davvero avuto effetto, non al click: i
   * filtri qui sono in AJAX, e fra il click e i prodotti aggiornati puo' fallire
   * la richiesta.
   */
  function filtroUsato(dati, sezione) {
    var conteggio = null;
    try {
      // La sezione appena arrivata porta il conteggio sulla sua radice, ma se
      // e' gia' stata innestata nel documento querySelector non la trova
      // guardando dentro: il dato sta sull'elemento stesso.
      var contenitore = sezione || document;
      var grezzo = contenitore.getAttribute && contenitore.getAttribute('data-products-count');
      if (grezzo == null && contenitore.querySelector) {
        var elemento = contenitore.querySelector('[data-products-count]');
        if (elemento) grezzo = elemento.getAttribute('data-products-count');
      }
      if (grezzo != null && grezzo !== '') conteggio = Number(grezzo);
    } catch (e) {
      /* il conteggio e' un di piu': se manca, l'evento parte lo stesso */
    }

    // Tipo pagina e collezione si leggono dal percorso e non da una classe sul
    // body: il body ha template-collection ma non ha nulla per la ricerca, e
    // dedurre "non e' collezione, quindi e' ricerca" sarebbe sbagliato ovunque
    // i filtri comparissero altrove.
    var percorso = window.location.pathname;
    var tipo = '';
    var collezione = '';
    var pezzi = percorso.split('/collections/');
    if (pezzi.length > 1) {
      tipo = 'collection';
      collezione = pezzi[1].split('/')[0].split('?')[0];
    } else if (percorso.indexOf('/search') >= 0) {
      tipo = 'search';
    }

    pubblica('filter_used', {
      filter_name: dati.name || '',
      filter_value: dati.value || '',
      filter_param: dati.param || '',
      filter_action: dati.action === 'remove' ? 'remove' : 'apply',
      page_type: tipo,
      collection_handle: collezione,
      results_count: conteggio
    });
  }

  /*
   * Richiesta "avvisami quando torna disponibile", andata a buon fine.
   *
   * Il modulo e' un form contact nativo di Shopify: ricarica la pagina e
   * segnala l'esito con form.posted_successfully. L'evento parte quindi al
   * caricamento dopo l'invio, che e' l'unico momento in cui sappiamo davvero
   * che l'iscrizione e' stata registrata -- il click da solo non lo dice.
   *
   * L'email inserita NON viene inviata: e' un dato personale e non serve.
   */
  var CHIAVE_DISPONIBILITA = 'guestside:back_in_stock';

  function richiestaDisponibilita(dati) {
    return pubblicaUnaVolta('back_in_stock_request', String(dati.item_product_id), {
      item_id: dati.item_id || '',
      item_name: dati.item_name || '',
      item_product_id: dati.item_product_id || '',
      request_status: 'success'
    });
  }

  // All'invio si annota soltanto quale prodotto: il modulo ricarica la pagina, e
  // al ritorno non ci sarebbe piu' modo di saperlo. Nessun campo compilato
  // dall'utente finisce qui dentro.
  function annotaInvioDisponibilita(form) {
    try {
      var contenitore = form.closest('.bls_popup-stock-notify');
      if (!contenitore) return;
      sessionStorage.setItem(CHIAVE_DISPONIBILITA, JSON.stringify({
        item_id: contenitore.getAttribute('data-item-id') || '',
        item_name: contenitore.getAttribute('data-item-name') || '',
        item_product_id: contenitore.getAttribute('data-item-product-id') || ''
      }));
    } catch (e) {
      /* navigazione privata o storage pieno: si perde l'evento, non l'iscrizione */
    }
  }

  /*
   * Al caricamento dopo l'invio.
   *
   * Non basta contact_posted=true: il tema usa {% form 'contact' %} anche per
   * altro (la richiesta dati fiscali), e Shopify segna il successo per tutti i
   * moduli contact della pagina. Il discriminante vero e' l'annotazione, che
   * viene scritta solo dal modulo disponibilita'.
   *
   * L'ancora serve solo a escludere: se Shopify riporta indietro il nome di un
   * altro modulo, quello e' stato inviato e non il nostro. Un ritorno senza
   * ancora si accetta, perche' non e' detto che Shopify la metta e non vale la
   * pena perdere l'evento su un'ipotesi.
   */
  function verificaRitornoDisponibilita() {
    try {
      if (window.location.search.indexOf('contact_posted=true') < 0) return;
      var ancora = window.location.hash;
      if (ancora && ancora !== '#FormStockNotify') return;
      var grezzo = sessionStorage.getItem(CHIAVE_DISPONIBILITA);
      if (!grezzo) return;
      sessionStorage.removeItem(CHIAVE_DISPONIBILITA);
      var dati = JSON.parse(grezzo);

      // Questo e' l'unico evento che parte a inizio pagina, quando
      // Shopify.analytics potrebbe non esserci ancora. Si riprova per cinque
      // secondi e poi si lascia perdere: un evento mancato non deve diventare
      // un timer che resta acceso.
      if (!richiestaDisponibilita(dati)) {
        var tentativi = 0;
        var attesa = setInterval(function () {
          tentativi++;
          if (richiestaDisponibilita(dati) || tentativi >= 20) clearInterval(attesa);
        }, 250);
      }
    } catch (e) {
      /* niente */
    }
  }

  // Delegato sul documento: il modulo arriva nel DOM dopo, iniettato nel popup.
  document.addEventListener('submit', function (evento) {
    var form = evento.target;
    if (form && form.classList && form.classList.contains('stock-notify-form')) {
      annotaInvioDisponibilita(form);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', verificaRitornoDisponibilita);
  } else {
    verificaRitornoDisponibilita();
  }

  return {
    pubblica: pubblica,
    pubblicaUnaVolta: pubblicaUnaVolta,
    osservaAggiuntaCarrello: osservaAggiuntaCarrello,
    filtroUsato: filtroUsato,
    richiestaDisponibilita: richiestaDisponibilita,
    normalizzaErrore: normalizzaErrore
  };
})();
